import { useContext } from 'react'
import { PopupBody, PopupText, BookingDetailsWrapper } from '../popup-styles'
import { BookingTitle, BookingDate } from '../../../atoms/Booking/booking-styles'
import { ApiContext } from '../../../../contexts/api-context'
import Popup from '../popup'
import { UserBooking } from '../../../../types/andTypes'
import { formatToReadableDate } from '../../../../utilities/utils'
import { ModalContext } from '../../../../contexts/modal-context'
import { LoginContext } from '../../../../contexts/login-context'
import logAnalyticsEvent from '../../../../utilities/firebase-analytics'

type DecisionPopupProps = {
  header: string
  decisionText?: string | null
  bookingDetails: UserBooking
  confirmAction: () => void
}

const DecisionPopup = ({
  header,
  decisionText,
  bookingDetails,
  confirmAction
}: DecisionPopupProps) => {
  const { setModalOpen } = useContext(ModalContext)
  const { userProfile } = useContext(ApiContext)
  const { businessUnits } = useContext(ApiContext)
  const displayName =
    businessUnits && businessUnits.find(bU => bU.id === bookingDetails.clubId)?.name

  const { user } = useContext(LoginContext)
  const closeModal = () => {
    setModalOpen(false)
    if (header === 'Cancel Booking') {
      logAnalyticsEvent('delete_decision_cancelled', {
        user: user?.email,
        team: userProfile?.team,
        booking_location: bookingDetails.clubId,
        default_location: userProfile?.businessUnit
      })
    } else {
      logAnalyticsEvent('booking_decision_cancelled', {
        user: user?.email,
        team: userProfile?.team,
        booking_location: bookingDetails.clubId
      })
    }
  }

  const buttonConfig = [
    {
      text: 'Confirm',
      onClick: confirmAction
    }
  ]

  return (
    <Popup header={header} buttonConfig={buttonConfig} onPopupClose={closeModal}>
      {decisionText ? <PopupText>{decisionText}</PopupText> : <></>}
      <PopupBody>
        <BookingDetailsWrapper data-testid="booking-details">
          <BookingTitle>{formatToReadableDate(bookingDetails.date)}</BookingTitle>
          <BookingDate>{displayName}</BookingDate>
        </BookingDetailsWrapper>
      </PopupBody>
    </Popup>
  )
}

export default DecisionPopup
